import PropTypes from 'prop-types'

import { MOBILE_HOME_TABS } from '../../../common/constants'
import { mobileShippingsTable } from '../../../common/propTypes'
import useTranslations from '../../../i18n/useTranslations'
import Tabs from '../../../ui/components/tabs'
import TableMobile from '../../../ui/components/TableMobile'
import Loader from '../Loader'

const ShippingsSummary = ({
  isLoading,
  data,
  states,
  onClickFilters,
  tabValue,
  onTabChange,
  onResetFilters,
  incidentsVisorRef,
  shipmentsVisorRef,
  unscheduledVisorRef,
  incidentsTotalResults,
  appliedFiltersNumber,
}) => {
  const t = useTranslations()

  const getDynamicTabs = data =>
    Object.entries(data).map(([key, value]) => {
      const isIncidents = key === MOBILE_HOME_TABS.INCIDENTS
      return {
        value: key,
        label: t(`noun:${key}`),
        content: (
          <>
            <TableMobile
              showFiltersButton={key !== MOBILE_HOME_TABS.UNSCHEDULED}
              appliedFiltersNumber={appliedFiltersNumber}
              states={states}
              data={value}
              onClickFilters={onClickFilters}
              onResetFilters={onResetFilters}
              type={key}
            />
            <div
              id={`${key}-visor`}
              ref={
                isIncidents
                  ? incidentsVisorRef
                  : key === MOBILE_HOME_TABS.UNSCHEDULED
                  ? unscheduledVisorRef
                  : shipmentsVisorRef
              }
            />
          </>
        ),
        badgeValue: isIncidents ? incidentsTotalResults : undefined,
      }
    })

  const handleTabChange = event => {
    document.getElementById('root')?.scrollIntoView({
      behavior: 'smooth',
    })
    onTabChange(event)
  }

  return isLoading ? (
    <Loader />
  ) : (
    <Tabs
      tabs={getDynamicTabs(data)}
      value={tabValue}
      onTabChange={handleTabChange}
    />
  )
}

ShippingsSummary.propTypes = {
  isLoading: PropTypes.bool,
  tabValue: PropTypes.oneOf(Object.values(MOBILE_HOME_TABS)),
  data: PropTypes.shape({
    incidents: mobileShippingsTable,
    shippings: mobileShippingsTable,
  }),
  incidentsTotalResults: PropTypes.number,
  states: PropTypes.object,
  appliedFiltersNumber: PropTypes.number,
  onClickFilters: PropTypes.func,
  onTabChange: PropTypes.func,
  onResetFilters: PropTypes.func,
  incidentsVisorRef: PropTypes.object,
  shipmentsVisorRef: PropTypes.object,
  unscheduledVisorRef: PropTypes.object,
}

export default ShippingsSummary
